import { useMemo } from 'react';

import {
  createInitialValues,
  createValidationSchema,
} from 'components/NEFIComponents/NEFISteps/NEFIStepFormUpload/NEFIFormUploadIVFunctions';

export const useNEFIFormUploadIV = (branchSelectionValues) => {
  return useMemo(() => {
    const initialValues = createInitialValues(
      branchSelectionValues ?? { isEnergyActive: false, isGasActive: false }
    );
    const validationSchema = createValidationSchema();

    return {
      initialValues,
      validationSchema,
    };
  }, [branchSelectionValues]);
};
